
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiParametriGlobaliGrid extends Serenity.EntityGrid<UtentiProdottiParametriGlobaliRow, any> {
        protected getColumnsKey() { return UtentiProdottiParametriGlobaliColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiParametriGlobaliDialog; }
        protected getIdProperty() { return UtentiProdottiParametriGlobaliRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiParametriGlobaliRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiParametriGlobaliRow.localTextPrefix; }
        protected getService() { return UtentiProdottiParametriGlobaliService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}